import styled from 'styled-components';
import { ColorAddiGrayDarken1, ColorAddiWhite } from '@addi/foundation/dist/mobile/colors';
import { Paragraph } from '../typographies';
const TRIANGLE_SIZE = 10;
export const TooltipContainer = styled.div `
  display: flex;
  padding: 9px 16px;
  border-radius: 4px;
  align-self: center;
  background-color: ${ColorAddiGrayDarken1};
`;
export const Text = styled(Paragraph) `
  font-weight: 400;
  font-size: 18px;
  line-height: 26.64px;
  color: ${ColorAddiWhite};
  margin: 0;
`;
export const TriangleContainer = styled.div `
  position: absolute;
  bottom: -5px;
  right: 20px;
`;
export const Triangle = styled.div `
  border-bottom-width: 1px;
  border-left-width: 1px;
  background-color: ${ColorAddiGrayDarken1};
  border-color: ${ColorAddiGrayDarken1};
  width: ${TRIANGLE_SIZE}px;
  height: ${TRIANGLE_SIZE}px;
  transform: rotate(-45deg);
`;
//# sourceMappingURL=tooltip-simple-info.styled.js.map